import React from 'react';
import { Check, Calendar } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/paau-asensio/30min';

const FreeAuditSection = ({ t }) => (
  <section id="auditoria" className="py-16 bg-blue-50 curtain-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10 scroll-reveal">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
          {t.audit.title} <span className="text-gradient">{t.audit.titleHighlight}</span>
        </h2>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
          {t.audit.subtitle}
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg scroll-reveal-scale">
        <ul className="space-y-4 mb-8 max-w-2xl mx-auto">
          {t.audit.points.map((point) => (
            <li key={point} className="flex items-start gap-3">
              <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-800 text-base md:text-lg">{point}</span>
            </li>
          ))}
        </ul>

        <div className="text-center">
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105 inline-flex items-center gap-3 shadow-lg"
            data-testid="audit-cta-book-btn"
          >
            <Calendar className="w-5 h-5" />
            {t.audit.cta}
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FreeAuditSection;
